import React from "react";
import { Link } from "react-router-dom";
import { MonoButton } from "../kits";

export default function RegistrationDataComponent({ registrations }) {
  return (
    <div className="mt-10">
      <h2 className="text-sm font-semibold mb-4 text-brand">Registrierte Teilnehmer</h2>
                      <Link to="/coursematerial">
  <MonoButton className="text-xs ">
    User Kurs Material  
  </MonoButton>
</Link>

      <div className="overflow-x-auto">
        <table className="table-auto w-full bg-white shadow-md rounded">
          <thead>
              <tr className="bg-black text-orange-50 text-xs">
              <th className="px-4 py-2 text-left">Kurs</th>
              <th className="px-4 py-2 text-left">Name</th>
              <th className="px-4 py-2 text-left">E-Mail</th>
              <th className="px-4 py-2 text-left">PDF</th>
              <th className="px-4 py-2 text-left">Gesendet am</th>
            </tr>
          </thead>
          <tbody>
            {registrations.map((r) => (
              <tr key={r.id} className="border-t text-xs">
                <td className="px-4 py-2 text-left">{r.course_title}</td>
                <td className="px-4 py-2 text-left">{r.first_name} {r.name}</td>
                <td className="px-4 py-2 text-left">{r.email}</td>
                <td className="px-4 py-2 text-left">
                  {r.pdf_path ? (
                    <a href={`stage01/uploads/${r.pdf_path}`} target="_blank" rel="noreferrer" className="text-blue-500 underline">
                      öffnen
                    </a>
                  ) : "–"}
                </td>
                <td>{r.email_sent_at || "–"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
